(function ($) {
    /* fixed sidebar with Table of Contents */
    function fixedSidebar(obj,windowWidth, top) {
        if(window.innerWidth > windowWidth && typeof obj == 'object' && obj.length > 0) {
            var header = $('.site-header');
            var footer = $('.site-footer');
            var headerHeight = $('.site-header').outerHeight() + 30;
            var breadcrumbsHeight = $('.breadcrumbs').outerHeight();
            $('.sp-left-col').height($('.sp-right-col').height());
            var objBottom = obj.offset().top + obj.outerHeight();


            if (($(document).scrollTop() < headerHeight && header.css("position") != 'fixed') || (header.css("position") == 'fixed' && $(document).scrollTop() < 100) ){
                obj.css('position','absolute');
                obj.css('top','0');
                obj.css('bottom','auto');

                if( top ) {
                    obj.css('position','relative');
                    obj.css('top', top);
                }
            }
            else if ( (footer.offset().top > obj.outerHeight() + objBottom ) || ( header.css("position") == 'fixed' && footer.offset().top > 2*obj.outerHeight() + $(document).scrollTop())){
                obj.css('position','fixed');
                obj.css('bottom','auto');
                if(header.css('position') == 'fixed'){
                    obj.css('top',headerHeight);
                } else {
                    obj.css('top', '30px');
                }

            } else if ( footer.offset().top < objBottom ) {
                obj.css('position','absolute');
                obj.css('top','auto');
                obj.css('bottom','0');
            }
        } else {
            $('.sp-left-col').height('auto');
            obj.css('position','relative');
            obj.css('top','auto');
            obj.css('bottom','0');
        }
    }

    // check screen width (mobile or desktop)
    function isMobile() {
        return $(window).width() <= 768;
    }

    function moveToClickedLink() {
        $(".table-of-contents-new a[href^=\"#\"] ").on('click', function(event) {
            //smooth scroll to the target
            event.preventDefault();
            let id = $(this).attr('href');
            let topOfBlock = $(id).offset().top;
            let headerHeight = $('header').outerHeight() ? $('header').outerHeight() + 20 : 0 ;
            $('body,html').animate({scrollTop: topOfBlock - headerHeight - 70}, 1000);
            //active link on click
            $('.table-of-contents-new .toc-list li').removeClass('invisible');
            $('.table-of-contents-new  .toc-list li a').removeClass('active');
            $(this).addClass('active').closest('li').addClass('visible').prevAll('li').removeClass('visible').addClass('invisible');
        })
    }

    function desktopTableOfContentFunc() {
        document.addEventListener('DOMContentLoaded', function (event) {
            if (event.target.className = "page-template-med-mal-guides-new") { // or any other filtering condition
                $(this).find('.toc-item.visible:first').addClass('visible--active');
            }
        });
        document.addEventListener('scroll', function (event) {
            if (event.target.className = "page-template-med-mal-guides-new" || event.target.className === "page-template-state-page") { // or any other filtering condition
                $(this).find('.toc-list li').removeClass('invisible');
                $(this).find('.toc-list a').removeClass('active');
                $(this).find('.toc-item.visible:first').prevAll('li').addClass('invisible');
                $(this).find('.toc-item.invisible').removeClass('visible--active');
                $(this).find('.toc-item.visible').removeClass('visible--active');
                $(this).find('.toc-item.visible:first').addClass('visible--active');
            }
        });

        moveToClickedLink()
    }

    function mobileTableOfContentFunc() {
        moveToClickedLink()
    }

    // Guide page sidebar nav behavior
    if ( !isMobile() ) {
        desktopTableOfContentFunc()
    }  else {
        $('.mainSideBar').removeClass('open')
        mobileTableOfContentFunc()
    }

    function openSideBar() {
        $('.mainSideBar .sp-caption').on('click', function (event) {
            event.stopImmediatePropagation();
            if($(window).width() <= 768) {
                $(this).closest('.mainSideBar').toggleClass('open')
                $(this).closest('.mainSideBar').hasClass('open') ? $('.mainSideBar .toc-list').slideDown() : $('.mainSideBar .toc-list').slideUp()
            }
        })
    }

    $(window).scroll(function () {
        let respondElement = $('.js-post__respond');

        if(respondElement.length) {
            let respondElementBottomPosition = respondElement.offset().top - respondElement.height();
            if($(window).scrollTop() > respondElementBottomPosition + 100){
                $('.js-post__articles').hide();
            }
            else {
                $('.js-post__articles').show();
            }
        }
    })

    /* function to fix the child block inside the parent when scrolling */
    function fixedChildIntoParentBlockFunc(page, parentBlock, fixedChildBlock, initialChildBlockTopOffset, fixedChildBlockTopOffset) {
        const rect = parentBlock[0].getBoundingClientRect();
        const bottomPosition = rect.bottom;

        if( $('body').hasClass(page)) {
            if ($(document).scrollTop() > parentBlock.offset().top
                && $(document).scrollTop() > (parentBlock.position().top + 200)
                && bottomPosition - window.innerHeight > 0) {
                fixedChildBlock.css('position', 'fixed');
                fixedChildBlock.css('top', fixedChildBlockTopOffset);
            } else {
                fixedChildBlock.css('position', 'relative');
                fixedChildBlock.css('top', initialChildBlockTopOffset);
            }
        }
        return false;
    }

    function fixedChildIntoParentCheckDeviceFunc() {
        if ( $('body.page-template-home-new') && $('.insurance-faq').length && !isMobile() ) {
            fixedChildIntoParentBlockFunc('page-template-home-new', $('.insurance-faq'),
                $('.insurance-faq .table-of-contents-new'),
                0, 100);
        }

        if ( $('body.page-template-tail-coverage-new') && $('.tail-content-wrapper').length && !isMobile() ) {
            fixedChildIntoParentBlockFunc('page-template-tail-coverage-new', $('.tail-content-wrapper'),
                $('.tail-content-wrapper .table-of-contents-new'),
                70, 100);
        }

        if ( $('body.page-template-med-mal-guides-new') && $('.guide-content-wrapper').length && !isMobile() ) {
            fixedChildIntoParentBlockFunc('page-template-med-mal-guides-new', $('.guide-content-wrapper'),
                $('.guide-content-wrapper .table-of-contents-new'),
                70, 100);
        }

        if ( $('body.page-template-state-page') && $('.guide-content-wrapper').length && !isMobile() ) {
            fixedChildIntoParentBlockFunc('page-template-state-page', $('.guide-content-wrapper'),
                $('.guide-content-wrapper .table-of-contents-new'),
                0, 100);
        }
    }

    function initTableOfContentFullHeightFunc() {
        let guidePageTableOfContent = $('.page-template-med-mal-guides-new .sp-left-col .table-of-contents-new');

        fixedSidebar(guidePageTableOfContent, 769, 77);
    }

    // trigger load/resize/orientationchange/scroll events
    $(window).on('scroll', function () {
        initTableOfContentFullHeightFunc();
        fixedChildIntoParentCheckDeviceFunc();
    });

    $(window).on('load resize orientationchange', function () {
        initTableOfContentFullHeightFunc();
        fixedChildIntoParentCheckDeviceFunc();
        openSideBar();
    })
})(jQuery);
